import { z } from 'zod/v4';

/**
 * State machine:
 *   ANALYSING → AWAITING_ANALYSIS → DONE
 *
 * - `ANALYSING`: initial state; parse-files has not yet run (or is running).
 * - `AWAITING_ANALYSIS`: parse-files has committed every zip-child `files`
 *   row, enqueued per-file jobs, and is now waiting for the status-checker
 *   to flip the row to DONE once every per-file job has landed. Set inside
 *   the parse-files transaction so a redelivered parse-files job can guard
 *   on `status !== 'ANALYSING'` and idempotently ACK-skip.
 * - `DONE`: every per-file job has completed (success or failure).
 */
export const StyleDocumentAiRequestStatusSchema = z.enum([
  'ANALYSING',
  'AWAITING_ANALYSIS',
  'DONE',
]);

export type StyleDocumentAiRequestStatusType = z.infer<
  typeof StyleDocumentAiRequestStatusSchema
>;

export const STYLE_DOCUMENT_AI_STATUS = {
  ANALYSING: 'ANALYSING',
  AWAITING_ANALYSIS: 'AWAITING_ANALYSIS',
  DONE: 'DONE',
} as const;
